import React, { useState } from 'react'
import Formvalidators from '../validators/Formvalidators';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FaRegEyeSlash } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa6";

export default function ForgetPassword3() {
  let [pstatus,setPstatus]= useState(false)
  let[data, setData]=useState({
    password:"",
    confirmPassword:""
  })
  let[show,setShow]= useState(false)
  let navigate = useNavigate()
  let [errorMessage,setErrorMessage]=useState({
    password:"",
  })
  
  const getInputData=(e)=>{
     let {name,value}=e.target;
     setErrorMessage("")
       if(name !=="confirmPassword"){
        setErrorMessage((x)=>{
          return{
            ...x,
          [name]:Formvalidators(e)
          }
        })
      }
      setData((x)=>{
        return{
          ...x,
           [name]:value
          }
      })
  }


//  async function postData(e){
//     e.preventDefault()
//      try {
//       let error = Object.values(errorMessage).find((x)=>x.length>0)
//       (error ,"erroe");
      
//       if(error){
//         setShow(true)
//       }
//       else if(data.password !== data.confirmPassword){
//         setShow(true)
//         setErrorMessage((x)=>{
//           return{
//             ...x,
//             password:"Passwor or confirm Password not match "
//           }
//         })
//       }
//       else{
//           let res =  await fetch ("http://34.228.14.188:8000/api/user/forget-password-3",{
//             method:"POST",
//             headers:{
//               "content-type":"application/json"
//             },
//           body: JSON.stringify({username :localStorage.getItem("password-reset-admin"), password:data.password})
//           }
//         )
//         (res);
        
//         res = await res.json()
//           if (res.result ==="Done"){
//              toast.success("Password Reset SuccessFully")
//              navigate("/signin")
//           }
//         }
//      } catch (error) {
//        alert(" InterNal Server Error , Please Try Again Letter")
//      }
//   }
async function postData(e) {
  e.preventDefault();

  let errors = {};

  if (!data.password) {
    errors.password = "Password is required";
  }

  if (!data.confirmPassword) {
    errors.confirmPassword = "Confirm Password is required";
  }

  if (data.password && data.confirmPassword && data.password !== data.confirmPassword) {
    errors.password = "Password and Confirm Password do not match";
  }

  if (Object.keys(errors).length > 0) {
    setErrorMessage(errors);
    setShow(true);
    return;
  }

  try {
    let res = await fetch("http://34.228.14.188:8000/api/user/forget-password-3", {
      method: "POST",
      headers: {
        "content-type": "application/json"
      },
      body: JSON.stringify({
        username: localStorage.getItem("password-reset-admin"),
        password: data.password
      })
    });

    res = await res.json();

    if (res.result === "Done") {
      toast.success("Password Reset Successfully");
      localStorage.removeItem("password-reset-admin")
      navigate("/signin");
    }
  } catch (error) {
    alert("Internal Server Error. Please Try Again Later.");
  }
}


  return (
    <>
        <div className="forget-pass-banner12">
            {/* <img src="/images/classicroom1.JPG" alt="" /> */}
        </div>

    <div className="container"> 
        <div className="main-forget">
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-sm-12 col-12 mt-3 forger-pass-left">
                    <img src="/images/forget-img.svg" alt="V_Hotel_the_grnad_shoba_forgetpassword3 " title='V_Hotel_the_grnad_shoba_forget_password3 title' />

                </div>
                <div className="col-md-6 col-sm-12 col-12 mt-5 forger-pass-right">
                <h1 className="mb-2">Forgot your password ??</h1>
          <p className="text-muted mb-4">
            Please enter the email address you'd like your password reset information sent to.
          </p>

          <form onSubmit={postData}>
            <div className="mb-3 col-md-12 forget-password-input">
                <p>Password*</p>
              <input 
                onChange={getInputData}
                name='password'
                type="text"
                className="form-control"
                placeholder="Enter your  Password "
              />
              {show && errorMessage ? <sup className='text-danger text-capitalize'>{errorMessage.password}</sup>:""}
            </div>
            <div className="mb-3 col-md-12 forget-password-input">
                <p> Confirm Password* </p>
              <input
               type= {`${pstatus? "text":"password"}`}
               name='confirmPassword'
                onChange={getInputData}
                className="form-control"
                placeholder="Enter your Confirm Password"
              />
              {/* {show && errorMessage ? <sup className='text-danger text-capitalize'>{errorMessage.password}</sup>:""} */}
            </div>
            <div className="mb-3 col-md-12 forget-btn  ">
              <button className="btn btn-primary w-100">
                Reset Your Password
              </button>
            </div>
               <span  onClick={()=>setPstatus(!pstatus)}>{pstatus?<FaRegEye className='password-icon' />:<FaRegEyeSlash  className='password-icon'/>}</span>
            {/* <div className="mb-3 col-md-12 forget-bakcToLogin">
             <Link  to='/signin'>
               <span className='text-center'>Back to Login</span> 
             </Link>
             
            </div> */}
           
          </form>
         
        </div>
                </div>
            </div>
        </div>
        </div>
    
    </>
  )
}
